export class AboutPage {

  _aboutPageWrapperEl;

  init() {
    this._aboutPageWrapperEl = document.querySelector('.about-us-page-wrapper');

    if (this._aboutPageWrapperEl) {
      new IntersectionObserver ( this.initNumbersAnimation.bind(this), {
        root: null,
        rootMargin: '0px',
        threshold: 0.45
      })
        .observe(this._aboutPageWrapperEl.querySelector('.numbers-section'));

      const milestoneObserver = new IntersectionObserver( this.initMilestonesAnimation.bind(this), {
        root: null,
        rootMargin: '0px',
        threshold: 0.05
      });

      this._aboutPageWrapperEl
        .querySelectorAll('.single-milestone')
        .forEach(milestone => {
          milestoneObserver.observe(milestone);
        });
    }
    return this;
  }

  initNumbersAnimation(entries, observer)  {
    entries.forEach(entry => {

      if ( entry.isIntersecting ) {
        this._aboutPageWrapperEl.querySelectorAll('.number--value')
          .forEach(number => {

          let current = +number.innerText;
          const target = +number.getAttribute('data-number');
          const increment = target / 300;

          const updateCounter = () => {

            if (current < target) {
              number.innerText = (current + increment).toFixed(0);
              current += increment;
              setTimeout(updateCounter, 1)
            } else {
              number.innerText = target
            }
          };
          updateCounter();
        });

        observer.disconnect();
      }
    })
  }

  initMilestonesAnimation(entries) {
    entries.forEach(entry => {
      if ( entry.isIntersecting ) {
        entry.target.classList.add('single-milestone--active');
      } else {
        entry.target.classList.remove('single-milestone--active');
      }
    })
  }
}
